import type { AccountManagementService } from "@/domain/port/AccountManagementService";
import type { IdempotencyKeyFactory } from "../port/IdempotencyKeyFactory";
import type { ReactivateBillingResult } from "../model/AccountBilling";

export class ReactivateAccountBilling {
  constructor(
    private readonly service: AccountManagementService,
    private readonly idempotencyKeyFactory: IdempotencyKeyFactory,
  ) {}

  execute(signal?: AbortSignal): Promise<ReactivateBillingResult> {
    return this.service.reactivateBilling(
      this.idempotencyKeyFactory.create(),
      signal,
    );
  }
}
